export const AUTH_ACTION = { LOGIN: 'login', FORGOT: 'forgot', SSO: 'sso', MFA: 'mfa' };
export const LOGIN_SUBSTATUS = { NEED_MFA: 19, REDIRECT: 20, NEED_SSO: 21, CANT_SSO: 22 };
export const GOOGLE_CLIENT_ID = '952991682077-ssbhjqpc8riqr02huvrb81f8o40l22ln.apps.googleusercontent.com';
export const SSO_ARTICLE_URL = 'https://singular.zendesk.com/hc/en-us/articles/115003223926-Single-Sign-on';
export const FREESIGNUP_STEP2_URL = '/react/freesignup/#/react/signup?step=2';
export const RESET_SENT_URL = '/reset-password-sent';
export const LOGIN_URL = '/login';
export const CANT_SSO_MESSAGE = 'This email domain is not associated with Single Sign-on.';
